import { push } from 'react-router-redux';

import {
  NOTIFICATION_DIALOG_MESSAGES,
  OFFLINE_PROMPT_DEBOUNCE,
} from 'Common/Constants';
import * as RoutingSelectors from 'Common/Selectors/RoutingSelector';
import * as DialogActions from 'Components/dialogs/state/actions';
import * as LoginActions from 'Pages/login/state/login/actions';
import * as LoginSelectors from 'Pages/login/state/selectors';

import * as types from './types';

export const setOnline = (online) => ({
  type: types.SET_ONLINE,
  payload: online,
});

export const setServerUp = (serverUp) => ({
  type: types.SET_SERVER_UP,
  payload: serverUp,
});

export const setOfflineMode = (offlineMode) => ({
  type: types.SET_OFFLINE_MODE,
  payload: offlineMode,
});

export const setOfflineSyncInProgress = (inProgress) => ({
  type: types.SET_OFFLINE_SYNCE_IN_PROGRESS,
  payload: inProgress,
});

/**
 * Creates the offline prompt thunks, isolates the timer scope
 */
const createOfflinePromptHandlers = () => {
  // keeps track of current timer
  let timeout = null;

  const showOfflinePrompt = () => (dispatch, getState) => {
    if (
      process.env.REACT_APP_DISABLE_OFFLINE_NOTIFICATION &&
      process.env.REACT_APP_DISABLE_OFFLINE_NOTIFICATION === 'true'
    ) {
      return;
    }

    const state = getState();

    const onPointOfSale = RoutingSelectors.getIsOnPointOfSale(state);
    const onLogin = RoutingSelectors.getIsOnLogin(state);
    const loginFormValues = LoginSelectors.getLoginFormValues(state);
    // user is on login page with the login form opened
    if (onLogin && loginFormValues) {
      dispatch(
        DialogActions.setNotificationDialog({
          ...NOTIFICATION_DIALOG_MESSAGES.API_INACCESSIBLE_LOGIN,
          actionsToDispatchOnOk: [LoginActions.setLoginOffline(true)],
        })
      );
    }
    // user is not on POS or login screen, and there's not already a timer, start the timer
    if (!onPointOfSale && !onLogin && !timeout) {
      timeout = setTimeout(() => {
        dispatch(
          DialogActions.setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.API_INACCESSIBLE,
            actionsToDispatchOnOk: [push('/home'), setOfflineMode(true)],
          })
        );
      }, OFFLINE_PROMPT_DEBOUNCE * 1000);
    }
  };

  const hideOfflinePrompt = () => (dispatch, getState) => {
    clearTimeout(timeout);
    timeout = null;
    dispatch(
      DialogActions.closeNotificationDialog(
        0,
        NOTIFICATION_DIALOG_MESSAGES.API_INACCESSIBLE.type
      )
    );
    dispatch(setOfflineMode(false));
  };

  return {
    showOfflinePrompt,
    hideOfflinePrompt,
  };
};

const { showOfflinePrompt, hideOfflinePrompt } = createOfflinePromptHandlers();

export { showOfflinePrompt, hideOfflinePrompt };



// WEBPACK FOOTER //
// ./src/state/connection/actions.js